import React from 'react';
import { Table } from '../../../shared/components';

const ReportTable = ({ data, columns, title }) => {
  console.log('ReportTable received data:', data);
  
  // Extract the actual data array from the response
  const reportData = data?.data || [];
  
  console.log('Extracted report data:', reportData);
  
  // Transform columns format to match your Table component
  const tableColumns = columns.map(col => ({
    title: col.header,
    key: col.accessor,
    sortable: true, // You can make this configurable if needed
    render: col.render // Store the render function for custom rendering
  }));

  // Process data to handle custom renderers
  const processedData = reportData.map(row => {
    const processedRow = { ...row };
    
    // Apply custom renderers if they exist
    columns.forEach(col => {
      if (col.render) {
        // Store the rendered value in a special property
        // or you can modify how the Table component renders
        processedRow[`_rendered_${col.accessor}`] = col.render(row[col.accessor], row);
      }
    });
    
    return processedRow;
  });

  // Custom cell renderer for the Table component
  const renderCell = (row, column) => {
    // If there's a render function for this column, use it
    const colConfig = columns.find(c => c.accessor === column.key);
    if (colConfig?.render) {
      return colConfig.render(row[column.key], row);
    }
    return row[column.key];
  };

  if (!reportData || !Array.isArray(reportData) || reportData.length === 0) {
    return (
      <div className="text-center py-12 bg-white rounded-lg border border-gray-200">
        <div className="mb-4">
          <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        </div>
        <p className="text-lg text-gray-600 mb-2">No data available for this report</p>
        <p className="text-sm text-gray-500">Try adjusting your filters or check back later</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
      {title && (
        <div className="px-6 py-4 border-b border-gray-200 bg-gray-50">
          <h3 className="text-lg font-medium text-gray-900">{title}</h3>
        </div>
      )}
      
      <Table
        columns={tableColumns}
        data={reportData}
        emptyMessage="No records found"
      />
      
      {/* Footer with record count */}
      <div className="px-6 py-3 border-t border-gray-200 bg-gray-50 text-sm text-gray-600">
        Showing {reportData.length} record{reportData.length !== 1 ? 's' : ''}
        {data?.type && (
          <span className="ml-2 text-gray-400">
            (Report type: {data.type})
          </span>
        )}
      </div>
    </div>
  );
};

export default ReportTable;